<div class="selected col-auto row" (click)="handleOnClickSelectDropdown();">
    <span class="col">{{(selected)?selected.label:'' }} </span>
    <svg class="col-auto" width="12" height="7" viewBox="0 0 12 7" fill="none">
        <path opacity="0.7" d="M1 1L6 6L11 1" stroke="#2A2E46" stroke-miterlimit="10" />
    </svg>
</div>
<ul class="options" [ngClass]="showOptions ? 'open-dropdown-select' : 'close-dropdown-select'">
    <ng-template ngFor let-item [ngForOf]="options">
        <li class="option" value="{{item.value}}" (click)="handleOnClickOption(item);">{{ item.label }}</li>
    </ng-template>
</ul>